const getFatZebraIFrame =
    (): HTMLIFrameElement => document.getElementsByClassName('fatzebra-iframe')[0] as HTMLIFrameElement;
const getFatZebraContinueButton =
    (): HTMLButtonElement => document.getElementById('paymentContinueButton') as HTMLButtonElement;

const getPaymentHost = () => {
    const fatZebraIframe = getFatZebraIFrame();

    return fatZebraIframe && fatZebraIframe.src.indexOf('sandbox') > 0
        ? 'https://paynow.sandbox.fatzebra.com.au'
        : 'https://paynow.fatzebra.com.au';
};

const transactionCompletedHandler = (payload: any) => {
    const fatZebraResult: HTMLInputElement = document.getElementById('paymentResult') as HTMLInputElement;
    fatZebraResult.value = JSON.stringify(payload.data);

    const fatZebraContinueButton = getFatZebraContinueButton();

    // We have to re-enabled the button because it was disabled during user-click in SubmitFatZebra.
    fatZebraContinueButton.disabled = false;
    fatZebraContinueButton.click(); // Submit the form again with value in hidden input
    // We disable the button again to ensure that this function won't be called again,
    //  because this function will always be called after a successful SubmitFatZebra call from user-click
    fatZebraContinueButton.disabled = true;
};

// Handle Save and continue button(booking form), pay now button(payment request portal)
const SubmitFatZebra = (event: Event) => {
    const fatZebraResult: HTMLInputElement = document.getElementById('paymentResult') as HTMLInputElement;

    // Hidden input not present
    if (fatZebraResult === null) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        return;
    }

    // Hidden input HAS NO response from iFrame yet
    if (!fatZebraResult.value) {
        // Disable submit button
        getFatZebraContinueButton().disabled = true;

        // Stop event propagation
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        // Post message to iFrame
        const ftzFrame: HTMLIFrameElement = getFatZebraIFrame();
        if (ftzFrame.contentWindow === null) { return; }
        ftzFrame.contentWindow.postMessage('doCheckout', getPaymentHost());
    }
};

// Listen to FatZebra iframe postMessage
const messageListener = (event: MessageEvent) => {
    if (event.origin !== getPaymentHost()) {
        return false;
    }

    // Older browsers will have a query-string style data payload
    // Whereas newer browsers will have an object
    let payload = event.data;
    if (typeof event.data === 'string') {
        if (/\[object/i.test(event.data)) {
            // Raised if the serialization failed
            alert('Sorry, it looks like there has been a problem communicating with your browser...');
        }
        // Deserialize into an object
        const pairs = payload.split('&');
        payload = {};
        for (let i = 0; i < pairs.length; i++) {
            const element = pairs[i];
            const kv = element.split('=');
            payload[kv[0]] = kv[1];
        }
    }

    /*
    * 25/04/2018
    * This if statement in FatZebra document breaks the next switch statement.
    * payload object will no longer contain message property.
    */
    // if ('data' in payload) {
    //    var payload = payload.data;
    // }
    switch (payload.message) {
        case 'transaction.error': // Credit card declined
        case 'transaction.complete':
            // Handle the transaction complete message.
            // Payload will be in e.data.data (eg. payload.data.r == 1)
            transactionCompletedHandler(payload);
            return true;
        // Handle the processing of the transaction - implementation optional.
        case 'transaction.processing':
        // Handle the transaction being cancelled (i.e. show message, re-display the window etc).
        case 'transaction.cancelled':
            return true;
        default:
            getFatZebraContinueButton().disabled = false;
            return false;
    }
};

if (window.addEventListener) {
    window.addEventListener('message', messageListener);
} else {
    (window as any).attachEvent('onmessage', messageListener);
}

export default SubmitFatZebra;
